module.exports = __webpack_public_path__ + "img/chara_line_3.477b437a.png";